import $ from 'jquery';

export default class PT {
    constructor(e) {
        this.$e = $(e);
        this.$img = this.$e.find('.pt__image img');
        if (this.$img.length) this.init();
    }

    init() {
        const offset = this.$img.height() - this.$img.parent().height();
        this.$e.css('padding-top', offset + 'px');
        this.$e.on('click', () => {
            window.location.href = this.$e.attr('data-link');
        });
    }
}